import { render, staticRenderFns } from "./TetraContactInfo.vue?vue&type=template&id=6d23b43b&scoped=true&lang=pug"
import script from "./TetraContactInfo.vue?vue&type=script&lang=js"
export * from "./TetraContactInfo.vue?vue&type=script&lang=js"
import style0 from "./TetraContactInfo.vue?vue&type=style&index=0&id=6d23b43b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23b43b",
  null
  
)

export default component.exports